import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {setSQFTAr3dPopup} from "../../../../../actions/sqftMenuFunctions";
import {generateQRCode} from "../../../helpers/sqft3dArHelper";
//import GLBLoader from "../ar3d/GLBLoader";
//import ARButton from "../ar3d/ARButton";
import MultiLoader from "../../../../ui/multiLoader";
import store from "../../../../../store";
import {setMultiLoader} from "../../../../../actions/actionFunctions";
import ARButton from "./ARButton";
import {DEVICE_TYPE, getDeviceType} from "../../../helpers/sqftMobileHelper";
import ARButtonGoogleWebXR from "./ARButtonGoogleWebXR";

const ARWorkspace = (props) => {
  const {cabinetsGlb, apiErrorMessage, abortRequestController} = props;
  const {isMobile} = props;
  const [qrImage, setQrImage] = useState(null)

  // useEffect(()=> {
  //   if (isMobile && cabinetsGlb) {
  //     new GLBLoader(cabinetsGlb);
  //   }
  // }, [isMobile, cabinetsGlb])

  useEffect(()=> {
    return () => {
      if (abortRequestController) {
        abortRequestController.abort();
      }
      store.dispatch(setMultiLoader({activeStep: 8, visible: false, finished: true}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!isMobile && cabinetsGlb) {
    const getARUrlForGlbFile = () => {
      const regex = /composed\/(.*?)\.glb/;
      const match = cabinetsGlb.match(regex);

      if (match && match.length > 1) {
        const extractedString = match[1];
        return window.location.origin + '/kitchen/#' + '/sqft-cabinets-ar/' + extractedString;
      }
      return ''
    }
    const arUrlForGlbFIle = getARUrlForGlbFile();
    generateQRCode(arUrlForGlbFIle).then((imageDataUrl) => {
      setQrImage(imageDataUrl);
    });
  }

  const getArButton = () => {
    switch (getDeviceType()) {
      case DEVICE_TYPE.Android:
        return <ARButtonGoogleWebXR url={cabinetsGlb} />
      case DEVICE_TYPE.iOS:
      case DEVICE_TYPE.unknown:
        return <ARButton url={cabinetsGlb} />
    }
  }

  return (
    <div className="arDWorkspace">
      <div className="ar-d-workspace">
        {cabinetsGlb ? (
          isMobile ? (
            getArButton()
          ) : (
            <div>
              <img src={qrImage} alt="QR Code" />
            </div>
          )
        ) : apiErrorMessage ? (
          apiErrorMessage
        ) : (
          <MultiLoader useCabinetLoader={true} />
        )}
      </div>
    </div>
  )
};

// ARWorkspace.propTypes = {
//   displayDoorsOnly: PropTypes.bool
// }

const mapStateToProps = (store) => ({
  ar3dPopup: store.sqftMenuState.ar3dPopup,
  cabinetsGlb: store.sqftState.cabinetsGlb,
  apiErrorMessage: store.sqftState.apiErrorMessage,
  isMobile: store.serverState.isMobile,
  abortRequestController: store.sqftState.abortRequestController,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup
};


export default connect(mapStateToProps, mapDispatchToProps)(ARWorkspace);
